<template>
  <div class="menu-section">
    <div v-for="(item, index) in menuList" :key="index">
      <div class="menu-card" @click="onMenuClick(item.path, index)" v-if="checkMenuShow(index)">
        <div class="menu-left">
          <img :src="item.img" alt="" class="menu-icon" />
          <span class="menu-text">{{ $t(item.name) }}</span>
          <div v-if="item.msg && item.isHaveIcons" class="sub_text">{{'🔴 '+ $t(item.msg) +' 🎁' }}</div>
          <div v-if="item.msg && !item.isHaveIcons" class="sub_text">{{ $t(item.msg) }}</div>
        </div>
        <span class="unreadCount" v-if="item.isSupport && unreadMsgCount>0">{{ unreadMsgCount }}</span>
        <img src="@/assets/profile/arrow_right_white45.png" alt="" class="arrow-icon" />
      </div>
    </div>
  </div>


</template>

<script setup lang="ts">
import { ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user';
import { clickOnMenuThemeThree, MENU_LIST_THEME_THREE, MENU_LIST_THEME_TWO } from '@/view/profile/supportScript'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import { useActivityStore } from '@/stores/activity'
const activityStore = useActivityStore()
const router = useRouter()
const menuList = ref(MENU_LIST_THEME_THREE)
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = defineEmits(['logout'])
const openLogoutPopup = inject<() => void>('openLogoutPopup')
const userStore = useUserStore()
const unreadMsgCount = computed(() => userStore.unreadCount)

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  clickOnMenuThemeThree(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}

const checkMenuShow = (index: number) => {
  if (index === 2) {
    const isAvailableRedeem = activityStore.activityList.some((obj: any) => obj.name === "redeem_code")
    if (isAvailableRedeem) {
      return true
    } else {
      return false
    }
  }

  return true
}
</script>

<style scoped>
.menu-section {
  /* background-color: #1b151f; */
  /* padding: 15px; */
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  background: #161d30;
}

.section-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: bold;
}

.menu-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  border-radius: 6px;
  margin-bottom: 10px;
  transition: all 0.2s;
  cursor: pointer;
}


.menu-left {
  display: flex;
  align-items: center;
  width: 100%;
}

.sub_text {
  font-size: 13px;
  text-align: right;
  width: 100%;
  margin-right: 10px;
  color: #8792af;
}

.menu-icon {
  width: 35px;
  height: 35px;
  margin-right: 10px;
}

.menu-text {
  color: #ffffff;
  font-size: 14px;
}

.arrow-icon {
  width: 12px;
  opacity: 0.8;
}

.unreadCount {
  color: #fff;
  background: red;
  border-radius: 22px;
  width: 16px;
  height: 15px;
  font-size: 12px;
  text-align: center;
  margin: 10px;
  padding: 3px;
}

.pop-animate {
  animation: pop-scale 0.25s ease;
}

@keyframes pop-scale {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.96);
  }

  100% {
    transform: scale(1);
  }
}

@media (max-width:450px) {
  .sub_text {
    font-size: 11px;
  }
}
</style>
